<template>
  <div class="content">
    <div class="container-fluid">
      <template v-if="mostrar">
        <div class="row">
          <div class="col-12">
            <card-item>
              <div class="d-flex justify-content-end">
                <button class="btn btn-danger btn-sm" @click="volver">
                  Volver
                </button>
              </div>
            </card-item>
          </div>
        </div>

        <div v-if="tengoClientes" class="row mt-3">
          <div class="col-12">
            <card-item>
              <div
                class="mb-3 drop-zone"
                @dragover.prevent
                @dragleave.prevent
                @drop.prevent="handleDrop"
              >
                <p>Arrastre y suelte archivos aquí o</p>
                <div class="row justify-content-center">
                  <div class="col-auto">
                    <label for="fileInput" class="btn btn-primary"
                      >Subir archivos</label
                    >
                    <input
                      type="file"
                      class="form-control d-none"
                      id="fileInput"
                      @change="handleFileUpload"
                      multiple
                    />
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
        <div v-else>Cargando...</div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12">
            <card-item>
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-danger btn-sm"
                  @click="volverACargarArchivos"
                >
                  Volver
                </button>
              </div>
            </card-item>
          </div>
        </div>
        <div
          v-for="(file, index) in selectedFiles"
          :key="index"
          class="row mt-4"
        >
          <div class="col-12">
            <card-item class="position-relative">
              <button
                v-if="!file.procesamientoExitoso"
                @click="removeFile(index)"
                class="btn btn-danger btn-sm position-absolute"
                style="
                  top: -15px;
                  right: -15px;
                  border-radius: 50%;
                  background-color: #ffff;
                "
              >
                X
              </button>

              <div class="container">
                <label for="">nombre de archivo:</label>
                <div class="row">
                  <div
                    class="file-name-container border rounded p-2 me-2 col-12 col-md-6 text-center"
                  >
                    {{ file.name }}
                  </div>
                  <div class="col-12 col-md-6">
                    <button
                      @click="submit(index)"
                      class="btn btn-primary btn-block"
                    >
                      Procesar pagos
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="file.preview" class="table-responsive mt-3">
                <table class="table table-striped table-hover">
                  <thead class="table-dark">
                    <tr>
                      <th>Fecha de cobro</th>
                      <th>Importe cobrado</th>
                      <th>Código de barras</th>
                      <th>Id Cliente</th>
                      <th>Cliente</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, itemIndex) in file.preview"
                      :key="itemIndex"
                    >
                      <td>
                        {{ $moment(item.fechaCobro).format("DD-MM-YYYY") }}
                      </td>
                      <td>{{ formatCurrency(item.importeCobrado) }}</td>
                      <td>{{ item.codigoDeBarras }}</td>
                      <td>{{ item.idCliente }}</td>
                      <td>{{ item.cliente }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="file.processingResult" class="mt-3">
                <div
                  v-if="file.processingResult.ok"
                  style="background-color: rgba(51, 125, 39, 0.5)"
                >
                  <pre
                    v-if="file.processingResult.resultadoPago"
                    style="font-size: 1em"
                    >{{ file.processingResult.resultadoPago }}</pre
                  >

                  <div
                    v-if="file.processingResult.resultadoIngresarPago"
                    style="font-size: 1em"
                  >
                    <p>
                      <strong
                        >Resultado de ingreso de pago por cada cliente:</strong
                      >
                    </p>
                    <div
                      v-for="result in file.processingResult
                        .resultadoIngresarPago"
                      :key="result.LineNum"
                    >
                      <pre
                        :class="{
                          'text-danger': result.Status === 0,
                          '': result.Status === 1,
                        }"
                      >
           El ingreso del pago del cliente {{ result.IdCliente }} de la linea {{
                          result.LineNum
                        }} arrojó como resultado: {{ result.Result }}.
          </pre
                      >
                    </div>
                  </div>
                </div>
                <div v-else class="alert alert-danger">
                  <p>
                    <strong>Error:</strong> {{ file.processingResult.message }}
                  </p>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "IngresoPagosRapipago",
  data() {
    return {
      selectedFiles: [],
      mostrar: true,
      tengoClientes: false,
    };
  },
  computed: {
    idClientesVigentes() {
      return this.$store.state.clientes.clientes;
    },
  },
  mounted() {
    this.$store.dispatch("clientes/getClientes").then(() => {
      this.tengoClientes = true;
    });
  },
  methods: {
    async volverACargarArchivos() {
      let confirmarVolver = await this.$bvModal.msgBoxConfirm(
        "¿Está seguro que desea regresar?",
        {
          title: "Confirmación",
          centered: true,
          okTitle: "SI",
          cancelTitle: "NO",
        },
      );
      if (confirmarVolver) {
        this.selectedFiles = [];
        this.mostrar = true;
      }
    },
    volver() {
      this.$router.push("/admin/pagos");
    },
    handleDrop(event) {
      event.preventDefault();
      this.addFiles(event.dataTransfer.files);
    },
    handleFileUpload(event) {
      this.addFiles(event.target.files);
    },
    async addFiles(files) {
      this.mostrar = false;
      for (const file of files) {
        if (this.isFileDuplicate(file.name)) {
          await this.$msgBoxOk({
            title: "Archivo Duplicado",
            text: `El archivo "${file.name}" ya existe. No se cargará de nuevo.`,
            okVariant: "warning",
          });
          continue;
        }

        const content = await this.readFileContent(file);
        const preview = this.parseFileContent(content);

        this.selectedFiles.push({
          file,
          name: file.name,
          content,
          preview,
          processingResult: null,
        });
      }
    },

    isFileDuplicate(fileName) {
      return this.selectedFiles.some((file) => file.name === fileName);
    },

    async removeFile(index) {
      const fileName = this.selectedFiles[index].name;
      this.selectedFiles.splice(index, 1);

      await this.$msgBoxOk({
        title: "Archivo Eliminado",
        text: `El archivo "${fileName}" ha sido eliminado.`,
      });
    },
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
      });
    },
    parseFileContent(content) {
      const parsedData = [];
      const normalizedContent = content.replace(/\r\n|\r/g, "\n");
      const lines = normalizedContent.split("\n");
      lines.forEach((line) => {
        if (
          line.length === 73 &&
          !["00000000", "99999999"].includes(line.substring(0, 8))
        ) {
          const idLineas = line.substring(33, 37).replace(/^0+/, "");
          const cliente = this.idClientesVigentes.find(
            (c) => c.id_cliente == idLineas,
          );
          parsedData.push({
            fechaCobro: line.substring(0, 8),
            importeCobrado: parseFloat(line.substring(9, 23)) / 100,
            codigoDeBarras: line.substring(24, 73),
            idCliente: idLineas,
            cliente: cliente ? cliente.nombre_web : "_cliente_no_vigente_",
          });
        }
      });
      return parsedData;
    },
    async verificarPagosVirtuales(index) {
      const fileData = this.selectedFiles[index];
      const idsClientes = fileData.preview
        .map((item) => item.idCliente)
        .join(",");

      try {
        const resp = await axios.post("/execute", {
          method: "CLI.VerificarPagosVirtualesVigentes",
          parameters: [{ name: "ids_clientes", value: idsClientes }],
        });

        if (
          resp.data.ok &&
          resp.data.result &&
          resp.data.result.length > 0 &&
          resp.data.result[0].length > 0
        ) {
          return resp.data.result[0];
        }
        return [];
      } catch (error) {
        console.error("Error al verificar pagos virtuales:", error);
        return [];
      }
    },
    async mostrarDialogoPagosVirtuales(clientesConPagosVirtuales) {
      return new Promise((resolve) => {
        const modalContent = this.$createElement("div", [
          this.$createElement(
            "p",
            {
              class: "mb-3 font-weight-bold",
            },
            "Los siguientes clientes tienen pagos virtuales vigentes:",
          ),

          this.$createElement("div", { class: "table-responsive" }, [
            this.$createElement(
              "table",
              { class: "table table-sm table-striped" },
              [
                this.$createElement("thead", { class: "table-dark" }, [
                  this.$createElement("tr", [
                    this.$createElement("th", "Cliente"),
                    this.$createElement("th", "Monto"),
                    this.$createElement("th", "Fecha y Hora Vigencia"),
                    this.$createElement("th", "Estado"),
                  ]),
                ]),

                this.$createElement(
                  "tbody",
                  clientesConPagosVirtuales.map((cliente) => {
                    const fechaVigencia = new Date(cliente.fecha_pago_virtual);
                    const fechaFormateada =
                      fechaVigencia.toLocaleDateString("es-AR");
                    const horaFormateada = fechaVigencia.toLocaleTimeString(
                      "es-AR",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      },
                    );
                    const horasVigencia = cliente.horas_vigencia || 0;
                    const diasVigencia = cliente.dias_vigencia || 0;
                    const monto = this.formatCurrency(cliente.monto_pago);

                    let estadoTexto, estadoClase;
                    if (horasVigencia > 24) {
                      estadoTexto = `${diasVigencia} días`;
                      estadoClase = "badge badge-success";
                    } else if (horasVigencia > 0) {
                      estadoTexto = `${horasVigencia}h restantes`;
                      estadoClase = "badge badge-warning";
                    } else {
                      estadoTexto = "Vencido";
                      estadoClase = "badge badge-danger";
                    }

                    return this.$createElement("tr", [
                      this.$createElement("td", [
                        this.$createElement(
                          "strong",
                          cliente.id_cliente.toString(),
                        ),
                      ]),
                      this.$createElement("td", monto),
                      this.$createElement(
                        "td",
                        `${fechaFormateada} ${horaFormateada}`,
                      ),
                      this.$createElement("td", [
                        this.$createElement(
                          "span",
                          {
                            class: estadoClase,
                          },
                          estadoTexto,
                        ),
                      ]),
                    ]);
                  }),
                ),
              ],
            ),
          ]),

          this.$createElement("div", { class: "alert alert-warning mt-3" }, [
            this.$createElement(
              "strong",
              "¿Desea eliminar estos pagos virtuales y procesar los pagos reales de Rapipago?",
            ),
          ]),
        ]);

        this.$bvModal
          .msgBoxConfirm([modalContent], {
            title: "⚠️ Pagos Virtuales Detectados",
            centered: true,
            okTitle: "Sí, eliminar y procesar",
            cancelTitle: "Cancelar operación",
            okVariant: "warning",
            cancelVariant: "secondary",
            size: "lg",
            headerClass: "bg-warning text-dark",
          })
          .then(resolve);
      });
    },
    async eliminarPagosVirtuales(clientesConPagosVirtuales) {
      const resultados = [];

      for (const cliente of clientesConPagosVirtuales) {
        try {
          const resp = await axios.post("/execute", {
            method: "CLI.EliminarPagoVirtual",
            parameters: [{ name: "id_cliente", value: cliente.id_cliente }],
          });

          if (resp.data.ok) {
            resultados.push({
              id_cliente: cliente.id_cliente,
              exito: true,
              mensaje: `Pago virtual eliminado correctamente`,
            });
          } else {
            resultados.push({
              id_cliente: cliente.id_cliente,
              exito: false,
              mensaje: resp.data.message || "Error desconocido",
            });
          }
        } catch (error) {
          console.error(
            `Error eliminando pago virtual cliente ${cliente.id_cliente}:`,
            error,
          );
          resultados.push({
            id_cliente: cliente.id_cliente,
            exito: false,
            mensaje: `Error: ${error.message}`,
          });
        }
      }

      return resultados;
    },
    async submit(index) {
      const fileData = this.selectedFiles[index];

      try {
        const clientesConPagosVirtuales =
          await this.verificarPagosVirtuales(index);

        if (clientesConPagosVirtuales.length > 0) {
          const confirmarEliminacion = await this.mostrarDialogoPagosVirtuales(
            clientesConPagosVirtuales,
          );

          if (!confirmarEliminacion) {
            console.log("Usuario canceló la eliminación de pagos virtuales");
            return;
          }

          const resultadosEliminacion = await this.eliminarPagosVirtuales(
            clientesConPagosVirtuales,
          );

          const erroresEliminacion = resultadosEliminacion.filter(
            (r) => !r.exito,
          );
          if (erroresEliminacion.length > 0) {
            let mensajeError = "Error al eliminar algunos pagos virtuales:\n\n";
            erroresEliminacion.forEach((error) => {
              mensajeError += `• Cliente ${error.id_cliente}: ${error.mensaje}\n`;
            });
            mensajeError += "\n¿Desea continuar procesando los demás pagos?";

            const continuarConErrores = await this.$bvModal.msgBoxConfirm(
              mensajeError,
              {
                title: "Errores en Eliminación",
                centered: true,
                okTitle: "Continuar",
                cancelTitle: "Cancelar",
                okVariant: "warning",
              },
            );

            if (!continuarConErrores) {
              return;
            }
          } else {
            await this.$msgBoxOk({
              title: "Pagos Virtuales Eliminados",
              text: `Se eliminaron exitosamente ${resultadosEliminacion.length} pagos virtuales.`,
              okVariant: "success",
            });
          }
        } else {
          console.log("No se detectaron pagos virtuales vigentes para los clientes del archivo");
        }

        const resp = await axios.post("/execute", {
          method: "CLI.IngresarRapipago",
          parameters: [
            { name: "nombre_de_archivo", value: fileData.name },
            { name: "contenido", value: fileData.content },
          ],
        });

        if (resp.data.ok) {
          const result = resp.data.result;
          let resultadoPago = "";
          let resultadoIngresarPago = [];

          if (
            result[result.length - 2] &&
            result[result.length - 2][0] &&
            result[result.length - 2][0].resultado
          ) {
            resultadoPago = `\n${result[result.length - 2][0].resultado}`;
          }

          if (
            result[result.length - 1] &&
            result[result.length - 1][0] &&
            result[result.length - 1][0].LineNum
          ) {
            resultadoIngresarPago = result[result.length - 1];
          }

          this.$set(this.selectedFiles[index], "processingResult", {
            ok: true,
            resultadoPago,
            resultadoIngresarPago,
          });
          this.$set(this.selectedFiles[index], "procesamientoExitoso", true);
        } else {
          this.$set(this.selectedFiles[index], "processingResult", {
            ok: false,
            message: resp.data.message,
          });
        }
      } catch (error) {
        console.error("Error en submit:", error);
        this.$set(this.selectedFiles[index], "processingResult", {
          ok: false,
          message: `Error inesperado: ${error.message}`,
        });
      }
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
      }).format(value);
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 20px;
  /* width: 100%; */
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.drop-zone:hover {
  background-color: #f8f8f8;
}
</style>